import { render, staticRenderFns } from "./loading-circle.vue?vue&type=template&id=506704c5"
import script from "./loading-circle.vue?vue&type=script&lang=js"
export * from "./loading-circle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports